import AnalyticsEventName from './analyticsEventName';
import type { IAnalyticsAdditionalEventData } from './definitions';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const heap: any;
declare const amplitude: {
    getInstance: () => {
        logEvent: (eventInput: string, eventProperties?: Record<string, unknown>) => void;
        logEventWithGroups: (
            eventInput: string,
            eventProperties: Record<string, unknown> | null,
            groups: Partial<Record<'Teams' | 'Projects', string>>,
        ) => void;
    };
};
declare const analyticsAdditionalEventData: IAnalyticsAdditionalEventData;

const isExcludedTeamAndProjectEvent = (eventName: AnalyticsEventName) =>
    [
        AnalyticsEventName.SIGNED_IN.toString(),
        AnalyticsEventName.SIGNED_OUT.toString(),
        AnalyticsEventName.REGISTRATION_FORM_COMPLETED.toString(),
    ].includes(eventName.toString());

const track = (eventName: AnalyticsEventName, eventProperties = {}) => {
    const heapLoaded = typeof heap !== 'undefined' && typeof heap.track === 'function';
    const amplitudeLoaded = typeof amplitude !== 'undefined';

    if (!heapLoaded && !amplitudeLoaded) {
        return;
    }

    const includeAdditionalEventData =
        typeof analyticsAdditionalEventData !== 'undefined' && !isExcludedTeamAndProjectEvent(eventName);

    try {
        if (heapLoaded) {
            const heapEventProps = includeAdditionalEventData
                ? { ...eventProperties, ...analyticsAdditionalEventData }
                : eventProperties;

            heap.track(eventName.toString(), heapEventProps);
        }

        if (amplitudeLoaded) {
            if (includeAdditionalEventData) {
                const groups = analyticsAdditionalEventData && {
                    ...(analyticsAdditionalEventData.project?.project_id && {
                        Projects: analyticsAdditionalEventData.project.project_id.toString(),
                    }),
                    ...(analyticsAdditionalEventData.team?.team_id && {
                        Teams: analyticsAdditionalEventData.team.team_id.toString(),
                    }),
                };

                amplitude.getInstance().logEventWithGroups(eventName.toString(), eventProperties, groups);
            } else {
                amplitude.getInstance().logEvent(eventName.toString(), eventProperties);
            }
        }
    } catch (e) {
        // Just in case
    }
};

export default track;
